export const USE_REVENUE_DASHBOARD = "partnerPortal:useRevenueDashboard";
export const USE_FRONTDESK_DASHBOARD = "partnerPortal:useFrontDeskDashboard";
export const USE_EVENT_DASHBOARD = "partnerPortal:useEventDashboard";
export const USE_OCCUPANCY_DASHBOARD = "partnerPortal:useOccupancyDashboard";
export const USE_VALIDATION_DASHBOARD = "partnerPortal:useValidationDashboard";
export const USE_VALETINSIGHTS_DASHBOARD =
  "partnerPortal:useValetInsightsDashboard";
export const USE_DAILY_LOCATION_SUMMARY_DASHBOARD =
  "partnerPortal:useDailyLocationSummaryDashboard";

export default {
  USE_REVENUE_DASHBOARD,
  USE_FRONTDESK_DASHBOARD,
  USE_EVENT_DASHBOARD,
  USE_OCCUPANCY_DASHBOARD,
  USE_VALIDATION_DASHBOARD,
  USE_VALETINSIGHTS_DASHBOARD,
  USE_DAILY_LOCATION_SUMMARY_DASHBOARD,
};
